import React from 'react';

interface GoogleDriveIconProps {
  size?: number;
  className?: string;
}

const GoogleDriveIcon: React.FC<GoogleDriveIconProps> = ({ size = 24, className = "" }) => {
  return (
    <svg 
      width={size} 
      height={size} 
      viewBox="0 0 24 24" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg" 
      className={className}
      aria-hidden="true"
    >
      <path d="M3.51105 18.4269L4.39307 19.9615C4.57634 20.2846 4.8398 20.5384 5.14908 20.723L8.29914 15.2307H1.99902C1.99902 15.5884 2.09066 15.9461 2.27394 16.2692L3.51105 18.4269Z" fill="#0066DA"></path>
      <path d="M11.999 8.76916L8.84897 3.27686C8.53969 3.46147 8.27623 3.71532 8.09295 4.03839L2.27394 14.1922C2.09403 14.5083 1.99926 14.8663 1.99902 15.2307H8.29914L11.999 8.76916Z" fill="#00AC47"></path>
      <path d="M18.8492 20.723C19.1585 20.5384 19.422 20.2846 19.6053 19.9615L19.9718 19.3269L21.7244 16.2692C21.9077 15.9461 21.9993 15.5884 21.9993 15.2307H15.6987L17.0394 17.8846L18.8492 20.723Z" fill="#EA4335"></path>
      <path d="M11.9982 8.76923L15.1483 3.27692C14.839 3.09231 14.4839 3 14.1173 3H9.87907C9.51252 3 9.15742 3.10385 8.84814 3.27692L11.9982 8.76923Z" fill="#00832D"></path>
      <path d="M15.6983 15.2307H8.29849L5.14844 20.723C5.45772 20.9076 5.81281 20.9999 6.17937 20.9999H17.8174C18.1839 20.9999 18.539 20.8961 18.8483 20.723L15.6983 15.2307Z" fill="#2684FC"></path>
      <path d="M18.8146 9.11532L15.9051 4.03839C15.7218 3.71532 15.4584 3.46147 15.1491 3.27686L11.999 8.76916L15.6989 15.2307H21.9876C21.9876 14.873 21.8959 14.5153 21.7127 14.1922L18.8146 9.11532Z" fill="#FFBA00"></path>
    </svg>
  );
};

export default GoogleDriveIcon;